import { useEffect, useState } from 'react';
import { Box } from '../box';
import { Flex } from '../flex';
import { Heading } from '../heading';
import { Text } from '../text';
export interface CountdownProps {
  endDate: string;
  locale: 'it' | 'en';
  compact?: boolean;
}

const useCountdown = (targetDate: string) => {
  const countDownDate = new Date(targetDate).getTime();

  const [countDown, setCountDown] = useState(
    countDownDate - new Date().getTime()
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime());
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownDate]);

  return getReturnValues(countDown);
};

const getReturnValues = (countDown: number) => {
  // calculate time left
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  return [days, hours, minutes, seconds];
};

export function Countdown(props: CountdownProps) {
  const [days, hours, minutes, seconds] = useCountdown(props.endDate);

  const countdown = {
    days,
    hours,
    minutes,
    seconds,
  };

  return (
    <Box width="100%">
      {!props.compact ? (
        <>
          {' '}
          <Text fontSize="1" color="neutral500" mb="2">
            {props.locale === 'it' ? 'Tempo rimanente' : 'Time Remaining'}
          </Text>
          <Flex justifyContent={'space-between'} width="100%">
            {Object.entries(countdown).map(([key, value]) => (
              <Box key={key} textAlign="center">
                <Heading as="div" fontSize={4}>
                  {value}
                </Heading>
                <Text fontSize="0" color="neutral500">
                  {value === 1
                    ? STRINGS[props.locale][key.slice(0, -1)].toUpperCase()
                    : STRINGS[props.locale][key].toUpperCase()}
                </Text>
              </Box>
            ))}
          </Flex>
        </>
      ) : (
        <>
          <Text fontSize="1" color="white" mb="2" textAlign="right" pr={2}>
            {props.locale === 'it' ? 'Tempo rimanente' : 'Time Remaining'}
          </Text>
          <Flex width="100%" justifyContent={'end'}>
            {Object.entries(countdown).map(([key, value]) => (
              <Flex
                key={key}
                textAlign="right"
                mr="2"
                alignItems={'start'}
                justifyContent={'space-evenly'}
              >
                <Flex
                  textAlign="center"
                  flexDirection="column"
                  alignItems="center"
                >
                  <Heading
                    as="div"
                    color="white"
                    textAlign={'right'}
                    fontSize="4"
                    fontWeight="normal"
                  >
                    {value}
                  </Heading>
                  <Text fontSize="0" color="white" mt={-2}>
                    {value === 1
                      ? STRINGS[props.locale][key.slice(0, -1)]
                      : STRINGS[props.locale][key]}
                  </Text>
                </Flex>
                {!key.startsWith('sec') && (
                  <Heading
                    as="div"
                    color="white"
                    textAlign={'center'}
                    fontSize="2"
                    p={2}
                  >
                    {' : '}
                  </Heading>
                )}
              </Flex>
            ))}
          </Flex>
        </>
      )}
    </Box>
  );
}

const STRINGS = {
  it: {
    day: 'Giorno',
    days: 'Giorni',
    hour: 'Ora',
    hours: 'Ore',
    minute: 'Minuto',
    minutes: 'Min',
    second: 'Sec',
    seconds: 'Sec',
  } as { [key: string]: string },
  en: {
    day: 'Day',
    days: 'Days',
    hour: 'Hour',
    hours: 'Hours',
    minute: 'Minute',
    minutes: 'Minutes',
    second: 'Second',
    seconds: 'Seconds',
  } as { [key: string]: string },
};

export default Countdown;
